import { post, getAuthenticatedRequestConfig } from '../client'
import { subscribeRegisterTokenSerializer } from '../../serializers/subscribeRegisterTokenSerializer'

export const subscribeRegisterTokenResource = (params = {}) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  post('/v1/subscribers', { ...params })
    .then((response) => subscribeRegisterTokenSerializer(response))
    .catch((error) => Promise.reject(error))

export const subscribeAuthenticatedRegisterTokenResource = (
  baseURL,
  authToken,
  authHeader,
  authScheme,
  params = {}
) => {
  const requestConfig = getAuthenticatedRequestConfig(
    baseURL,
    authToken,
    authHeader,
    authScheme,
    params
  )

  return subscribeRegisterTokenResource(requestConfig)
}

export default subscribeRegisterTokenResource
